/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export function ownerDocument(node?: Document | HTMLElement | null): Document {
  return node?.ownerDocument || document;
}
